const inventory = document.querySelector(
  ".product product-info .product__inventory"
)
if (inventory) {
  const update = () => {
    document.body.classList.toggle(
      "variant-out-of-stock",
      !!inventory.querySelector(".out-of-stock")
    )
  }
  update() // set on load
  new MutationObserver(update).observe(inventory, { childList: true, subtree: true })
}